module.exports = __webpack_public_path__ + "assets/images/nav-right-caret.57ff3ac322231ca3ab4f7cfdda380e8b.svg";